

import compressorImage from "../../../static/images/distant_bass_suite/compressor.webp"
import { Box, Typography, Grid } from "@mui/material";

const PostFX = () => {
  return <Box sx={{ p: 5, background: "#1a1a1a", justifyContent: "center", alignItems: "center" }} >

    <Grid container justifyContent={"center"} alignItems={"center"} spacing={4} sx={{ background: "#1a1a1a" }}>
      <Grid item xs={12} md={4} sx={{ order: { xs: 2, md: 1 } }}>
        <Typography variant="h3" sx={{ textAlign: "left", mb: 3 }}>Compressor</Typography>
        <Typography variant="h6" sx={{ textAlign: "left" }}>Take control of your bass dynamics with dedicated attack, release, threshold, knee, ratio, and makeup gain controls. From subtle level smoothing to tight, assertive compression, the Compressor keeps every note consistent without losing impact.</Typography>
      </Grid>
      <Grid item xs={12} md={7} sx={{ order: { xs: 1, md: 2 } }}>
        <Box component="img" src={compressorImage} alt="BassSuite - Distant compressor" sx={{ display: "block", width: "100%", height: "auto" }} />
      </Grid>
    </Grid>

  </Box>
}

export default PostFX;
